import { Layout, Typography } from 'antd';
import { useObservable, useObserver } from 'mobx-react-lite';
import moment from 'moment';
import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import logo from '../assets/chirp_logo.png';
import GlobalHeader from '../components/GlobalHeader';
import { SideMenu } from '../components/Menu';
import { UserAlertBanners } from '../components/UserAlertBanners';
import { appData, authentication } from '../stores';

import styles from './BasicLayout.module.less';

const { Header, Content, Footer, Sider } = Layout;

interface IBasicLayoutProps {
  pageTitle?: string;
  pageDescription?: React.ReactNode;
  children?: ReactNode;
}

export const BasicLayout: React.FC<IBasicLayoutProps> = (props) => {
  useObservable(appData);
  useObservable(authentication);

  return useObserver(() => {
    const { pageTitle, pageDescription, children } = props;
    const { collapsedMenu } = appData;
    const { userAlerts } = authentication;

    return (
      <Layout style={{ minHeight: '100vh' }}>
        <Sider collapsed={collapsedMenu} width={215}>
          <Link to='/dashboard' className={styles.logo}>
            <img src={logo} alt='chrip-logo' className={styles.img} />
          </Link>
          <SideMenu />
        </Sider>
        <Layout>
          <UserAlertBanners userAlerts={userAlerts} />
          <Header style={{ background: '#fff', padding: 0 }}>
            <GlobalHeader
              collapsed={collapsedMenu}
              onCollapse={() => appData.toggleMenu()}
            />
          </Header>
          <Content>
            {pageTitle && (
              <div className={styles.pageHeader}>
                <Typography.Title level={4} style={{ margin: 0, padding: 0, lineHeight: 2 }}>
                  {pageTitle}
                </Typography.Title>
                {pageDescription && (
                  <Typography.Paragraph style={{ paddingTop: 5, paddingBottom: 5 }}>
                    {pageDescription}
                  </Typography.Paragraph>
                )}
              </div>
            )}
            <div
              className={styles.content}
              style={!pageTitle ? { marginTop: '32px' } : undefined}
            >
              {children}
            </div>
          </Content>
          <Footer style={{ textAlign: 'center' }}>
            Chirp Systems, Inc. {moment(new Date()).format('YYYY')}
          </Footer>
        </Layout>
      </Layout>
    );
  });
};

export default BasicLayout;
